import ContactUs from "../../components/ContactUs";
import StayInLoop from "../../components/StayInLoop";
import AchieveOutcome from "../../components/AchieveOutcome/AchieveOutcome";
import {
    ProductHeroVideo,
    AIDrivenProjectPerformance,
    ConnectedWorkforceAssets,
    DownstreamRefiningProcessing,
    EPProductionAnalytics,
    ESGSustainabilityManagement,
    EVTransportIntelligence,
    FuelRetailCustomerOperations,
    MidstreamGasDistribution,
    ProcessSafetyManagement,
    UpstreamOperations,
    AboutIED,
} from "../../constant";
import WeAreIED from "../../components/WeAreIED";
import AnimatedCardCrausal from "../../components/AnimatedCardCrausal";
import IndustriesVideoSection from "../../components/IndustiesVideoSection";
import OilAndGasLanding from "../../components/Industries/OilAndGasLanding";

const tabsData =
{
    title: "Smarter Operations. Safer Workplaces. Sustainable Growth.",
    subTitle: "Available as a unified platform or modular solutions, IENERGY helps oil & gas organizations digitize operations, improve EHS and ESG performance, connect workers and assets, automate compliance processes, and leverage actionable insights to drive efficiency, reduce risk, and deliver measurable business outcomes.",
    videoUrl: AboutIED,
    cardData: [
        {
            title: "Upstream Operations",
            icon:UpstreamOperations,
            subtitle: "Explore. Produce. Optimize.",
            description:
                "Connect field operations, improve safety, and maximize production performance",
        },
        {
            title: "Midstream & Gas Distribution",
            icon:MidstreamGasDistribution,
            subtitle: "Transport with Visibility and Control.",
            description:
                "Monitor pipelines and networks while ensuring safety and compliance.",
        },
        {
            title: "Downstream Refining & Processing",
            icon:DownstreamRefiningProcessing,
            subtitle: "Drive Efficiency Across Complex Operations",
            description:
                "Digitize refinery processes, reduce risks, and improve operational performance.",
        },
        {
            title: "Fuel Retail & Customer Operations",
            icon:FuelRetailCustomerOperations,
            subtitle: "Connected Networks. Better Service",
            description:
                "Enhance retail operations, compliance, workforce productivity, and customer experience.",
        },
    ],
};


const AnimatedCardCrausalData = [
    {
        icon:EPProductionAnalytics,
        title: "E&P Production Analytics",
        description:
            "Optimize production performance through real-time operational visibility, advanced analytics, and field intelligence for informed decision-making and enhanced asset productivity.",
    },
    {
        icon:ProcessSafetyManagement,
        title: "Process Safety Management",
        description:
            "Strengthen operational safety through digital permits, risk controls, incident management, and proactive monitoring of critical safety processes",
    },
    {
        icon:ESGSustainabilityManagement,
        title: "ESG & Sustainability Management",
        description: "Track emissions, sustainability performance, environmental obligations, and regulatory disclosures to support responsible and transparent operations.",
    },
    {
        icon:ConnectedWorkforceAssets,
        title: "Connected Workforce & Assets",
        description: "Connect personnel, equipment, and operational processes to improve productivity, collaboration, asset reliability, and field execution efficiency.",
    },
    {
        icon:EVTransportIntelligence,
        title: "EV Transport Intelligence",
        description: "Optimize fleet utilization, charging infrastructure, route planning, energy consumption, and operational performance across electric mobility networks.",
    },
    {
        icon:AIDrivenProjectPerformance,
        title: "AI-Driven Project Performance",
        description: "Improve project delivery through predictive insights, progress monitoring, risk identification, resource optimization, and performance-driven decision support.",
    },

];





export default function OilAndGasPage() {
    return (
        <>
            <OilAndGasLanding />
            <IndustriesVideoSection data={tabsData} />
            <AnimatedCardCrausal
                title={"Enabling the Future of Energy Operations"}
                subTitle={"Empower upstream, midstream, downstream, city gas distribution, and fuel retail operations with connected data, operational visibility, sustainability management, and intelligent decision support. IENERGY helps organizations improve safety, optimize assets, strengthen compliance, and accelerate business performance through integrated digital solutions."}
                data={AnimatedCardCrausalData}
            />
            <AchieveOutcome
                title={`Advancing Operational Excellence Across Energy Operations`}
                subTitle={`Enable better decisions, stronger governance, and improved performance through connected energy operations and actionable business intelligence.`}
            />
            <WeAreIED title={"Connected by Data. Driven by Performance."} subtitle={"From production facilities and pipeline networks to processing plants and retail operations, IENERGY delivers the visibility needed to coordinate activities, manage obligations, and support informed decision-making across complex operating environments."} />
            <ContactUs />
            <StayInLoop />
        </>
    );
}
